import { useDispatch } from 'react-redux'

import axios from '../api/axios'
import { setCredentials, encryptStorage } from '../slices/authSlice'

const useSilentLogin = () => {
	const dispatch = useDispatch()

	const handleSilentLogin = async (accountObj, isFirst = false) => {
		try {
			const { data } = await axios.post(
				`/account/loginWithAD?isFirst=${isFirst}`,
				{
					fullName: accountObj.name,
					email: accountObj.username,
					uid: accountObj.localAccountId,
					email2: accountObj.email
				},
				{
					headers: {
						Authorization: `Bearer ${process.env.REACT_APP_AD_TOKEN}`
					}
				}
			)

			encryptStorage.setItem('znxpefwwcs', data.data.table[0])

			if (isFirst) {
				encryptStorage.setItem('rft', data.refreshToken)
			}

			await dispatch(
				setCredentials({
					accessToken: data.accessToken,
					refreshToken: data.refreshToken,
					userInfo: data.data.table[0]
				})
			)

			return data.data.table[0]
		} catch (err) {
			//
		}
	}

	return { handleSilentLogin }
}

export default useSilentLogin
